import React from 'react';

export function Select({ size = 'md', invalid = false, options = [], children, className = '', ...rest }) {
  return (
    <span className="sp-selectwrap">
      <select
        className={[
          'sp-input', 'sp-select', size !== 'md' && 'sp-input--' + size,
          invalid && 'sp-input--invalid', className
        ].filter(Boolean).join(' ')}
        {...rest}
      >
        {children || options.map(o => (
          typeof o === 'string'
            ? <option key={o} value={o}>{o}</option>
            : <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </span>
  );
}
